
import React from 'react';
import react ,{createContext} from 'react';
import useFirebase from '../hooks/UseFirebase';
export  const AuthContext = createContext();
const AuthProvider = ({children}) => {
    const  allContext = useFirebase();
    return (
        <AuthContext.Provider value={allContext}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthProvider;